import i18n from "@/lib/i18n";

const LEGACY_COLOR_MAP: Record<string, string> = {
  "#42af22": "#1a7f37",
  "#c98d21": "#9a6700",
  "#d85d4f": "#cf222e",
};

export const ensureAccessibleStatusColor = (color: string): string => {
  return LEGACY_COLOR_MAP[color.toLowerCase()] ?? color;
};

export const StatusList = {
  onTrack: "OnTrack",
  atRisk: "AtRisk",
  offTrack: "OffTrack",
  blocked: "Blocked",
} as const;

export const ALLOWED_STATUS_LIST = Object.values(StatusList);
export type StatusType = (typeof ALLOWED_STATUS_LIST)[number];

export const statusTypefromString = (str: string): StatusType | undefined => {
  // Support both old format ("On Track") and new format ("OnTrack")
  if (str === StatusList.onTrack || str === "On Track") {
    return StatusList.onTrack;
  }
  if (str === StatusList.atRisk || str === "At Risk") {
    return StatusList.atRisk;
  }
  if (str === StatusList.offTrack || str === "Off Track") {
    return StatusList.offTrack;
  }
  if (str === StatusList.blocked || str === "Blocked") {
    return StatusList.blocked;
  }
  return undefined;
};

export const sortStatus = (a?: string, b?: string, desc: boolean = false): 0 | 1 | -1 => {
  const numberFromType = (s?: string) => {
    if (s === StatusList.blocked || s === "Blocked") return desc ? 3 : 0;
    if (s === StatusList.offTrack || s === "Off Track") return desc ? 2 : 1;
    if (s === StatusList.atRisk || s === "At Risk") return desc ? 1 : 2;
    if (s === StatusList.onTrack || s === "On Track") return desc ? 0 : 3;

    return -1;
  };

  const numA = numberFromType(a);
  const numB = numberFromType(b);

  if (numA - numB > 0) {
    return 1;
  }
  if (numA - numB < 0) {
    return -1;
  }

  return 0;
};

export const colorForStatusType = (statusType: StatusType): string => {
  switch (statusType) {
    case StatusList.onTrack:
      return "#1a7f37";
    case StatusList.atRisk:
      return "#9a6700";
    case StatusList.offTrack:
      return "#cf222e";
    case StatusList.blocked:
      return "#44484F";
  }
};

export const displayNameForStatusType = (statusType: StatusType): string => {
  switch (statusType) {
    case StatusList.onTrack:
      return i18n.t("statusType.onTrack", { ns: "common" });
    case StatusList.atRisk:
      return i18n.t("statusType.atRisk", { ns: "common" });
    case StatusList.offTrack:
      return i18n.t("statusType.offTrack", { ns: "common" });
    case StatusList.blocked:
      return i18n.t("statusType.blocked", { ns: "common" });
  }
};
